export default "__VITE_ASSET__CGDZOIWJ__"